const roles = {
  Parent: 'Parent',
  Caretaker: 'Caretaker',
  Educator: 'Educator',
  Employee: 'Employee',
  Other: 'Other',
};

export default roles;
